export default class Header {
  constructor(title) {
    this.title = title;
  }

  createHeader() {
    const header = document.createElement('header');
    const titleH1 = document.createElement('h1');
    titleH1.innerHTML = this.title;
    header.appendChild(titleH1);
    document.body.appendChild(header);
  }

  init() {
    this.createHeader();
  }
}
